interface UiState {
    feedbackTemplateOpen: boolean;
    selectedLanguage: string;
}

export const initialUiState: UiState = {
    feedbackTemplateOpen: false,
    selectedLanguage: 'en',
    
};